import type { Errors } from 'io-ts';

import { AppError } from './AppError';

export class SpecificationError extends AppError {
    constructor(originalError: Errors, messages: string[]) {
        super('SpecificationError', originalError, 'Specification error', messages);
    }
}

export const createSpecificationNotFoundError = (originalError: Errors) =>
    new SpecificationError(originalError, ['Specification not found']);
